import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

const constants = new Constants();
const httpService = new HttpService();

export async function getPaginatedLiveCallsFromToStartDate(
  session_id,
  from,
  to,
  page,
  size
) {
  try {
    return await httpService.getJson(
      constants.liveCallServiceURLs.getLiveCallsFromToStartDate +
        `from/${from}` +
        `/to/${to}` +
        `/page/${page}` +
        `/size/${size}`,
      session_id
    );
  } catch (e) {
    throw e;
  }
}

export async function liveCallsSearch(
  session_id,
  from,
  to,
  page,
  size,
  aNumber,
  bNumber,
  cNumber
) {
  try {
    return await httpService.getJson(
      constants.liveCallServiceURLs.searchLiveCalls +
        `from/${from}` +
        `/to/${to}` +
        `/page/${page}` +
        `/size/${size}` +
        `?` +
        `aNumber=${aNumber || ""}` +
        `&bNumber=${bNumber || ""}` +
        `&cNumber=${cNumber || ""}`,
      session_id
    );
  } catch (e) {
    throw e;
  }
}
